import React, { useState, useEffect } from "react";
import { Grid, Typography } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { makeStyles } from "@material-ui/styles";
import { useSelector } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ToggleButtonGroup,
  ToggleButton,
  Box,
  Tooltip,
  IconButton,
  TextField,
} from "@material-ui/core";
import configData from "../../../../config";
import axios from "axios";
// import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

// style const
const useStyles = makeStyles((theme) => ({
  navContainer: {
    width: "100%",
    maxWidth: "350px",
    minWidth: "200px",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "10px",
    [theme.breakpoints.down("sm")]: {
      minWidth: "100%",
    },
  },
  headerAvatar: {
    cursor: "pointer",
    ...theme.typography.mediumAvatar,
    margin: "8px 0 8px 2px !important",
  },
  profileChip: {
    // flexGrow: 1,
    height: "40px",
    alignItems: "center",
    borderRadius: "25px",
    transition: "all .2s ease-in-out",
    borderColor: theme.palette.primary.light,
    backgroundColor: theme.palette.secondary.main,
    '&[aria-controls="menu-list-grow"], &:hover': {
      borderColor: theme.palette.primary.main,
      background: theme.palette.primary.main + "!important",
      color: theme.palette.primary.light,
      "& svg": {
        stroke: theme.palette.primary.light,
      },
    },
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  profileLabel: {
    lineHeight: 1.2,
    padding: "10px",
  },
  listItem: {
    marginTop: "5px",
  },
  cardContent: {
    padding: "16px !important",
  },
  card: {
    backgroundColor: theme.palette.primary.light,
    marginBottom: "16px",
    marginTop: "16px",
  },
  searchControl: {
    width: "100%",
    paddingRight: "8px",
    paddingLeft: "16px",
    marginBottom: "16px",
    marginTop: "16px",
  },
  startAdornment: {
    fontSize: "1rem",
    color: theme.palette.grey[500],
  },
  flex: {
    display: "flex",
  },
  name: {
    marginLeft: "2px",
    fontWeight: 400,
  },
  ScrollHeight: {
    height: "100%",
    maxHeight: "calc(100vh - 250px)",
    overflowX: "hidden",
  },
  badgeWarning: {
    backgroundColor: theme.palette.warning.dark,
    color: "#fff",
  },
  tableWithBorders: {
    borderCollapse: "collapse",
    width: "100%",
    "& th, & td": {
      border: "1px solid #ccc",
    },
  },
  customTypography: {
    [theme.breakpoints.down("lg")]: {
      fontSize: "9px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "9px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "9px",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "9px",
    },
    [theme.breakpoints.between("xs", "sm")]: {
      fontSize: "8px",
    },
    [theme.breakpoints.between("sm", "md")]: {
      fontSize: "8px",
    },
    [theme.breakpoints.between("md", "lg")]: {
      fontSize: "8px",
    },
  },
  modalStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    backgroundColor: theme.palette.background.paper,
    borderRadius: "10px",
    boxShadow: 24,
    padding: theme.spacing(3),
    outline: "none",
  },
}));

const ProfileDetails = ({ open, onClose }) => {
  const classes = useStyles();
  const account = useSelector((state) => state.account);
  const [credits, setCredits] = React.useState(100);
  const [mail, setMail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [whatsapp, setWhatsapp] = React.useState("");
  const [renewal, setRenewal] = React.useState("");
  const [location, setLocation] = React.useState(null);
  //Profile Starts Here
  const [meterData, setMeterData] = React.useState({});
  const [expanded, setExpanded] = useState(null);
  //Edit
  const [editOpen, setEditOpen] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [editName, setEditName] = useState("");
  const [oldName, setOldName] = useState("");
  const [newName, setNewName] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [minThreshold, setMinThreshold] = useState("");
  const [maxThreshold, setMaxThreshold] = useState("");
  const [shiftTime, setShiftTime] = useState("");
  const [shiftTimeError, setShiftTimeError] = useState("");
  const [editGroupId, setEditGroupId] = useState(""); 

  const handleAccordionChange = (panel) => (e, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  // const { isLoaded } = useJsApiLoader({
  //   id: "google-map-script",
  //   googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY, // 🔐 Move to .env
  // });

  const renderTable = (rows = [], columns = [], groupId = "") => (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell
            style={{ fontSize: "1rem", fontWeight: "600", color: "#545454" }}
          >
            Sr.No
          </TableCell>
          {columns.map((col, idx) => (
            <TableCell
              key={`${col}-${idx}`}
              style={{ fontSize: "1rem", fontWeight: "600", color: "#545454" }}
            >
              {col}
            </TableCell>
          ))}
          <TableCell
            style={{ fontSize: "1rem", fontWeight: "600", color: "#545454" }}
          >
            Actions
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row, i) => {
          const nameToEdit = row.meter_name || row.location_name || "";

          return (
            <TableRow key={`row-${i}`}>
              <TableCell
                style={{
                  fontSize: "1rem",
                  fontWeight: "600",
                  color: "#545454",
                }}
              >
                {i + 1}
              </TableCell>
              {columns.map((col, idx) => (
                <TableCell
                  key={`${col}-${i}`}
                  style={{
                    fontSize: "1rem",
                    fontWeight: "600",
                    color: "#545454",
                  }}
                >
                  {row[col.toLowerCase().replace(/\s/g, "_")] || "-"}
                </TableCell>
              ))}
              <TableCell>
                <Button
                  size="small"
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    setEditRow(row);
                    setOldName(nameToEdit);
                    setEditName(nameToEdit);
                    setNewName("");
                    setMinThreshold(row.min_threshold || "");
                    setMaxThreshold(row.max_threshold || "");
                    // setShiftTime(row.shift_time || "");
                    // Keep full HH:mm:ss
                    setShiftTime(row.shift_time || "00:00:00");
                    setSuccessMsg("");
                    setEditGroupId(groupId);
                    setEditOpen(true);
                  }}
                >
                  Edit
                </Button>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );

  const fetchAccessData = async () => {
    try {
      const token = account.token;
      const response = await axios.get(configData.API_SERVER + "user/profile", {
        headers: { Authorization: `Bearer ${token}` },
      });

      setCredits(response.data.credit || 0);
      setMail(response.data.client_email || "");
      setPhone(response.data.contact_no || "");
      setWhatsapp(
        Array.isArray(response.data.whatsapp_number) &&
          response.data.whatsapp_number.length > 0
          ? response.data.whatsapp_number[0].number
          : "N/A"
      );
      setRenewal(response.data.renewal_date || "");
      setMeterData(response.data || {});

      // Parse location from API
      if (response.data.location) {
        const [latStr, lngStr] = response.data.location.split(",");
        const lat = parseFloat(latStr);
        const lng = parseFloat(lngStr);

        // Check for valid coordinates
        if (!isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0) {
          setLocation({ lat, lng });
          return; // ✅ stop here, we already have a good location
        }
      }

      // ❌ If no valid location, fallback to device GPS
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            setLocation({
              lat: pos.coords.latitude,
              lng: pos.coords.longitude,
            });
          },
          (err) => {
            console.error("Geolocation error:", err);
            setLocation(null);
          },
          { enableHighAccuracy: true, timeout: 10000 }
        );
      } else {
        console.warn("Geolocation not supported in this browser");
        setLocation(null);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchAccessData();
  }, [account.token]);

  React.useEffect(() => {
    if (!location) {
      if (navigator.geolocation) {
        const watchId = navigator.geolocation.watchPosition(
          (pos) => {
            setLocation({
              lat: pos.coords.latitude,
              lng: pos.coords.longitude,
            });
          },
          (err) => {
            console.error("Geolocation error:", err);
            setLocation(null);
          },
          { enableHighAccuracy: true, maximumAge: 10000, timeout: 10000 }
        );

        return () => navigator.geolocation.clearWatch(watchId);
      } else {
        setLocation(null);
      }
    }
  }, [location]);

  const handleUpdateClick = async () => {
    try {
      const token = account.token;

      const formData = new FormData();
      if (location) {
        formData.append("location", `${location.lat},${location.lng}`);
      }

      const response = await axios.post(
        `${configData.API_SERVER}user/profile`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // You might want to update state or notify user here after success
      console.log("Location updated successfully:", response.data);
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  // const handleUpdateMeter = async () => {
  //   try {
  //     const token = account.token;

  //     const formData = new FormData();
  //     formData.append("meter_id", editRow?.id);
  //     formData.append("change_name", newName);

  //     await axios.post(
  //       `${configData.API_SERVER}user/edit_meter_name`,
  //       formData,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );

  //     // decide label
  //     const type = editRow?.meter_name ? "Meter Name" : "Location Name";

  //     setSuccessMsg(`${type} Changed from ${oldName} to ${newName}`);

  //     // ✅ refresh profile data
  //     await fetchAccessData();

  //     // close dialog after short delay
  //     setTimeout(() => {
  //       setEditOpen(false);
  //       setSuccessMsg("");
  //     }, 1500);
  //   } catch (error) {
  //     console.error("Update Error:", error);
  //   }
  // };

  const handleUpdateMeter = async () => {
    try {
      const token = account.token;

      const formData = new FormData();
      formData.append("meter_id", editRow?.id);

      if (newName) formData.append("change_name", newName);
      formData.append("min_threshold", minThreshold);
      formData.append("max_threshold", maxThreshold);
      // formData.append("shift_time", shiftTime);
      const formattedShiftTime = shiftTime
        ? shiftTime.length === 5
          ? `${shiftTime}:00`
          : shiftTime
        : "00:00:00";

      formData.append("shift_time", formattedShiftTime);

      await axios.post(
        `${configData.API_SERVER}user/edit_meter_name`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setSuccessMsg("Config Updated Successfully");

      await fetchAccessData();

      setTimeout(() => {
        setEditOpen(false);
        setSuccessMsg("");
      }, 1500);
    } catch (error) {
      console.error("Update Error:", error);
    }
  };

  const renderStandardTable = (data = []) =>
    renderTable(data, ["Meter Name", "Shift Time"]);

  const MeterGroupAccordion = ({ id, title, tabs }) => {
    const [selected, setSelected] = useState(tabs[0]?.label);
    const totalCount = tabs.reduce(
      (sum, tab) => sum + (meterData[tab.key]?.length || 0),
      0
    );

    // Group IDs where toggle buttons should be hidden
    const skipButtonGroups = [
      "ems",
      "bms",
      "trans",
      "vib",
      "steam",
      "nbs",
      "air",
      "agr",
      "gas",
      "solar",
      "boiler",
      "flms",
      "flms_own",
    ];

    const showToggleButtons = !skipButtonGroups.includes(id);

    return (
      <Accordion
        expanded={expanded === id}
        onChange={handleAccordionChange(id)}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <b>
            {title} -{" "}
            <span style={{ color: totalCount === 0 ? "#f22c3d" : "#351e99" }}>
              {totalCount} Meters
            </span>
          </b>
        </AccordionSummary>
        <AccordionDetails>
          {showToggleButtons ? (
            <>
              <ToggleButtonGroup
                value={selected}
                exclusive
                onChange={(e, val) => setSelected(val)}
              >
                {tabs.map((tab) => (
                  <ToggleButton key={`${id}-${tab.label}`} value={tab.label}>
                    {tab.label}
                  </ToggleButton>
                ))}
              </ToggleButtonGroup>
              {tabs.map(
                (tab) =>
                  selected === tab.label &&
                  (tab.columns
                    ? renderTable(meterData[tab.key], tab.columns, id)
                    : renderStandardTable(meterData[tab.key]))
              )}
            </>
          ) : (
            // Directly render all tabs (no toggle buttons)
            tabs.map((tab) =>
              tab.columns
                ? renderTable(meterData[tab.key], tab.columns, id)
                : renderStandardTable(meterData[tab.key])
            )
          )}
        </AccordionDetails>
      </Accordion>
    );
  };

  const groups = [
    // {
    //   id: "ems",
    //   title: "Ems",
    //   tabs: [{ label: "Energy Meters", key: "ems_meters" }],
    // },
    {
      id: "ems",
      title: "Ems",
      tabs: [
        {
          label: "Energy Meters",
          key: "ems_meters",
          columns: [
            "Meter Name",
            "Min Threshold",
            "Max Threshold",
            "Shift Time",
          ],
        },
      ],
    },
    {
      id: "water",
      title: "Water",
      tabs: [
        { label: "Water Meters", key: "wms_meters" },
        { label: "Water Controller", key: "water_controller" },
      ],
    },
    {
      id: "dg",
      title: "DG",
      tabs: [
        { label: "DG Meters", key: "dg_meters" },
        { label: "DG Controller", key: "dg_controller" },
      ],
    },
    {
      id: "trans",
      title: "Transformer",
      tabs: [{ label: "Transformer Meters", key: "trans_meters" }],
    },
    {
      id: "bms",
      title: "UPS",
      tabs: [{ label: "Battery Meters", key: "bms_meters" }],
    },
    {
      id: "aqi",
      title: "Air Quality",
      tabs: [
        {
          label: "Temp Sensors",
          key: "temp_meters",
          columns: ["Location Name", "Sensor Name", "Shift Time"],
        },
        { label: "Indoor Sensors", key: "indoor_aqi_sensors" },
        { label: "Outdoor Sensors", key: "outdoor_aqi_sensors" },
        { label: "Hooter Sensors", key: "hooter_meters" },
      ],
    },
    {
      id: "hvac",
      title: "HVAC",
      tabs: [
        { label: "Chiller Meters", key: "chiller_meters" },
        { label: "Dex Meters", key: "dex_meters" },
        { label: "AHU Meters", key: "ahu_meters" },
        { label: "Cooling Tower Meters", key: "cooling_meters" },
        { label: "Pump Meters", key: "pumps_meters" },
      ],
    },
    {
      id: "vib",
      title: "Vibration",
      tabs: [{ label: "Vibration Sensors", key: "vib_meters" }],
    },
    {
      id: "fms",
      title: "Fire System",
      tabs: [
        { label: "Fire Meters", key: "fms_meters" },
        { label: "Pressure Sensor", key: "fms_pressure_sensors" },
      ],
    },
    {
      id: "steam",
      title: "Steam Sensor",
      tabs: [{ label: "Steam Sensors", key: "steam_sensors" }],
    },
    {
      id: "nbs",
      title: "NBSafe",
      tabs: [{ label: "NBSafe", key: "nbs_meter" }],
    },
    {
      id: "agr",
      title: "Agriculture",
      tabs: [{ label: "Agriculture", key: "agr_meter" }],
    },
    {
      id: "gas",
      title: "Gas",
      tabs: [{ label: "Gas Sensors", key: "gas_sensors" }],
    },
    {
      id: "air",
      title: "Air Sensor",
      tabs: [{ label: "Air Sensors", key: "air_sensors" }],
    },
    {
      id: "flms",
      title: "Flms",
      tabs: [{ label: "Fleet Management", key: "fleet_sensors" }],
    },
    {
      id: "flms_own",
      title: "Flms Own",
      tabs: [{ label: "Fleet Management", key: "fleet_sensors" }],
    },
    {
      id: "solar",
      title: "Solar Sensor",
      tabs: [{ label: "Solar Sensors", key: "solar_sensors" }],
    },
    {
      id: "boiler",
      title: "Boiler",
      tabs: [{ label: "Boiler Sensors", key: "boiler_sensors" }],
    },
    // {
    //   id: "environment",
    //   title: "Environment",
    //   tabs: [
    //     { label: "Gas Sensors", key: "gas_sensors" },
    //     { label: "Air Sensors", key: "air_sensors" },
    //     { label: "NBS Meters", key: "nbs_meter" },
    //     { label: "Agri Sensors", key: "dex_meters" },
    //   ],
    // },
  ];

  return (
    <React.Fragment>
      <Dialog open={open} onClose={onClose} maxWidth="md">
        <DialogTitle
          style={{ fontSize: "1.2rem", fontWeight: "600", color: "#351e99" }}
        >
          Profile Details
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <Table className={classes.tableWithBorders}>
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    color: "#212121",
                    backgroundColor: "#f7f6fe",
                  }}
                >
                  User Name
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    color: "#212121",
                    backgroundColor: "#f7f6fe",
                  }}
                >
                  Client Email
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    color: "#212121",
                    backgroundColor: "#f7f6fe",
                  }}
                >
                  Phone No
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    color: "#212121",
                    backgroundColor: "#f7f6fe",
                  }}
                >
                  Whatsapp No
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    color: "#212121",
                    backgroundColor: "#f7f6fe",
                  }}
                >
                  Renewal Date
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    color: "#212121",
                    backgroundColor: "#f7f6fe",
                  }}
                >
                  Credits
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    color: "#545454",
                  }}
                >
                  {account?.user?.name || "-"}
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    color: "#545454",
                  }}
                >
                  {mail}
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    color: "#545454",
                  }}
                >
                  {phone}
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    color: "#545454",
                  }}
                >
                  {whatsapp}
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    color: "#545454",
                  }}
                >
                  {renewal}
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                  }}
                >
                  <span
                    style={{
                      color:
                        credits <= 20
                          ? "red"
                          : credits <= 60
                          ? "orange"
                          : "green",
                    }}
                  >
                    {credits}
                  </span>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>

          {/* <Grid item xs={12} style={{ marginTop: "20px" }}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box display="flex" alignItems="center">
                <Typography
                  variant="h4"
                  style={{
                    fontWeight: 600,
                    color: "#351e99",
                    marginRight: "8px",
                  }}
                >
                  Site Location
                </Typography>

                <Tooltip
                  title={
                    <span>
                      <b>Guide:</b> Pin your Site Area and then click on{" "}
                      <b>Update Location</b> to save the location.
                    </span>
                  }
                  arrow
                >
                  <IconButton size="small" color="primary">
                    <InfoOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>

              <Button
                variant="contained"
                color="primary"
                onClick={handleUpdateClick}
              >
                Update Location
              </Button>
            </Box>

            <div style={{ marginTop: "10px", height: "200px", width: "100%" }}>
              {isLoaded && location ? (
                <GoogleMap
                  mapContainerStyle={{ height: "100%", width: "100%" }}
                  center={location}
                  zoom={16}
                  onClick={(e) => {
                    setLocation({
                      lat: e.latLng.lat(),
                      lng: e.latLng.lng(),
                    });
                  }}
                >
                  <Marker
                    position={location}
                    draggable={true}
                    onDragEnd={(e) =>
                      setLocation({
                        lat: e.latLng.lat(),
                        lng: e.latLng.lng(),
                      })
                    }
                  />
                </GoogleMap>
              ) : (
                <div>Loading map...</div>
              )}
            </div>
          </Grid> */}

          <Grid item xs={12}>
            <Box
              sx={{
                backgroundColor: "#E3F2FD",
                borderLeft: "4px solid #2196F3",
                padding: 2,
                borderRadius: 1,
                margin: "5px 0",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 600,
                  textDecoration: "underline",
                  marginBottom: 1,
                }}
              >
                Note: Charges will apply
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 0.5,
                }}
              >
                <Typography variant="body2">• For SMS</Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#f22c3d", fontWeight: "bold" }}
                >
                  1 Credit
                </Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2">• For WhatsApp</Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#f22c3d", fontWeight: "bold" }}
                >
                  0.5 Credit
                </Typography>
              </Box>
            </Box>
          </Grid>

          <div style={{ margin: "20px 0 10px 0" }}>
            <h2
              style={{
                fontSize: "1.3rem",
                fontWeight: "700",
                color: "#351e99",
              }}
            >
              All Meter & Sensor Info
            </h2>
          </div>

          {groups.map((group) => (
            <MeterGroupAccordion key={group.id} {...group} />
          ))}
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handlePassword} color="primary">
            Change Password
          </Button> */}
          <Button onClick={onClose} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={editOpen}
        onClose={() => setEditOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Edit Name</DialogTitle>

        {/* <DialogContent>
          <Typography style={{ marginBottom: 10, fontWeight: 600 }}>
            Existing Name : {editName}
          </Typography>

          <TextField
            label="Enter New Name"
            fullWidth
            margin="dense"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
          />

          {successMsg && (
            <Typography style={{ marginTop: 12, fontWeight: 600 }}>
              Meter Name for <span style={{ color: "red" }}>{oldName}</span>{" "}
              Changed to <span style={{ color: "green" }}>{newName}</span>
            </Typography>
          )}
        </DialogContent> */}
        <DialogContent>
          <Typography style={{ marginBottom: 10, fontWeight: 600 }}>
            Existing Name : {editName}
          </Typography>

          <TextField
            label="Enter New Name"
            fullWidth
            margin="dense"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
          />

          {/* Min Threshold */}
          {editGroupId === "ems" && (
            <>
              <TextField
                label="Min Threshold"
                type="number"
                fullWidth
                margin="dense"
                value={minThreshold}
                onChange={(e) => setMinThreshold(e.target.value)}
              />
              <TextField
                label="Max Threshold"
                type="number"
                fullWidth
                margin="dense"
                value={maxThreshold}
                onChange={(e) => setMaxThreshold(e.target.value)}
              />
            </>
          )}

          {/* Shift Time */}
          <TextField
            label="Shift Time"
            type="text"
            fullWidth
            margin="dense"
            value={shiftTime}
            onChange={(e) => {
              const value = e.target.value;
              setShiftTime(value);

              // Validate HH:mm:ss format
              const isValid = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/.test(
                value
              );
              if (!isValid) {
                setShiftTimeError("Incorrect format. Use HH:mm:ss");
              } else {
                setShiftTimeError("");
              }
            }}
            placeholder="HH:mm:ss"
            InputLabelProps={{
              shrink: true,
            }}
            helperText={shiftTimeError || "Enter time in HH:mm:ss format"}
            error={Boolean(shiftTimeError)}
          />

          {successMsg && (
            <Typography
              style={{
                marginTop: 12,
                fontWeight: 600,
                color: "green",
                textAlign: "center",
              }}
            >
              {successMsg}
            </Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setEditOpen(false)}>Cancel</Button>

          {/* <Button
            variant="contained"
            color="primary"
            onClick={handleUpdateMeter}
            disabled={!newName}
          >
            Update
          </Button> */}
          <Button
            variant="contained"
            color="primary"
            onClick={handleUpdateMeter}
            disabled={!newName || Boolean(shiftTimeError)}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default ProfileDetails;
